import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { NAVIGATION_REQUEST, PROJECTS_REQUEST, PROJECT_CREATE_REQUEST, PROJECT_DELETE_REQUEST, PROJECT_EDIT_PAGE_REQUEST } from "../../redux/action_constant";
import WebService from "../../utility/WebService";
import API from "../../utility/API-endPoints";
import { projectDeleteFailure, projectDeleteSuccess, projectEditPageSuccess, projectFailure, projectSuccess } from "./ProjectAction";
import { createOrUpdateProjectInterface, ProjectAddOrEditPageRequest, ProjectEditPageRequest, ProjectInterface, ProjectRequestPayload, ProjectsRequest, ProjectsRequestFailure, ProjectsRequestSuccessPayload, ProjectState } from "./ProjectTypes";
import routePaths from "../../Navigation/routePaths";
import { reduxInitialState } from "../onBoarding/onBoardingTypes";
import { toast } from "react-toastify";

export const getOnBoardingReducer = (state: reduxInitialState) => state.ProjectReducer;

const getProjets = async (payload: ProjectRequestPayload) => {
    payload.page = payload.page ? (Number(payload.page) - 1) : 0;
    let query = new URLSearchParams(payload as any).toString();
    const data = await WebService.getAPI({
        action: API.PROJECT_LIST + query,
        body: {},
    }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const deleteProjet = async (payload: string) => {
    const data = await WebService.deleteAPI({ action: API.PROJECT_DELETE + "/" + payload, }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const createOrUpdateProject = async (payload: createOrUpdateProjectInterface) => {
    const isUpdate = payload.isEdit;
    const data = await WebService[isUpdate ? 'putAPI' : 'postAPI']({
        action: isUpdate ? API.PROJECT_UPDATE : API.PROJECT_CREATE,
        body: payload.data,
        id: 'project_create_update_btn'
    }).then(async (res: any) => {
        if (!payload.isEdit && payload.file) {
            await uploadProjectImage(payload.file, { uuid: res.uuid, file_name: payload.data.file_name, size: payload.data.file_size, length: payload.data.length || 0, width: payload.data.width || 0 });
        }
        return res;
    }).catch((e: any) => { return null })
    return data;
};

const uploadProjectImage = async (data: any, req: { uuid: string, file_name: string, size: string, length: number, width: number }) => {
    await WebService.postAPI({ action: `upload/project/image`, body: req, id: "project_create_update_btn" }).then(async (res: any) => { }).catch(async (error: any) => { });
};

function* projectRequestSaga(action: ProjectsRequest) {
    try {
        const response: ProjectsRequestSuccessPayload = yield call(getProjets, action.payload);
        if (!response) { throw new Error(); }
        yield put(projectSuccess(response));
    } catch (e: any) {
        yield put(projectFailure(e.message));
    }
};

function* editProjectPageRequestSaga(action: ProjectEditPageRequest) {
    yield put(projectEditPageSuccess(action.payload));
    yield put({ type: NAVIGATION_REQUEST, payload: routePaths.UPDATE_PROJECT.path });
};

function* deleteProjectRequestSaga(action: ProjectsRequestFailure) {
    try {
        const data: ProjectState = yield select(getOnBoardingReducer);
        const uuid = data.deleteProject.uuid;
        const response: { message: string } = yield call(deleteProjet, uuid);
        toast.success(response.message);
        if (!response) { throw new Error(); };
        yield put(projectDeleteSuccess());
        try {
            const projectResponse: ProjectsRequestSuccessPayload = yield call(getProjets, { page: 1 });
            if (!projectResponse) { throw new Error(); }
            yield put(projectSuccess(projectResponse));
        } catch {
            yield put(projectFailure('Failed to fetch project list'));
        }
    } catch {
        yield put(projectDeleteFailure());
    }
};

function* createOrUpdateProjectRequestSaga(action: ProjectAddOrEditPageRequest) {
    try {
        const response: { message: string, uuid: string } = yield call(createOrUpdateProject, action.payload);
        if (!response) { throw new Error(); }
        toast.success(response.message);
        yield put({ type: NAVIGATION_REQUEST, payload: routePaths.MARK_UNIT.path + response.uuid });
        console.log("response", response);

        return response;
    } catch {
        toast.error('Failed to create project');
    }
};

function* ProjectSaga() {
    yield all([takeLatest(PROJECTS_REQUEST, projectRequestSaga)]);
    yield all([takeLatest(PROJECT_EDIT_PAGE_REQUEST, editProjectPageRequestSaga)]);
    yield all([takeLatest(PROJECT_DELETE_REQUEST, deleteProjectRequestSaga)]);
    yield all([takeLatest(PROJECT_CREATE_REQUEST, createOrUpdateProjectRequestSaga)]);
};

export default ProjectSaga;